module.exports = __webpack_public_path__ + "img/lg_bj.4184d953.jpg";